<template>
    <div v-if="warningMessagePayment">
        <div class="alert-wrapper">
            <div class="alert alert-warning alert-dismissible" role="alert">
                {{ warningMessagePayment }}
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
/**
 * This component will be used to other component replacing the code
 * <div
        v-if="warningMessagePayment"
        class="alert alert-warning m-0 ml-md-3 mt-2 mt-md-0"
        role="alert"
    >
        {{ warningMessagePayment }}
    </div>
 */
import { isEmpty, isNil, trim } from "lodash";
export default {
    props: {
        invoiceId: {
            type: [String, Number],
            default: null
        },
        /** Used in payment modal only */
        invoiceIds: {
            type: [Array],
            default: () => []
        },
        module: {
            type: [String],
            required: true,
            validator: function (value) {
                return (
                    [
                        "medical-record",
                        "invoice",
                        "patient-invoice",
                        "payment-modal"
                    ].indexOf(value) !== -1
                );
            }
        }
    },
    computed: {
        warningMessagePayment() {
            let userChooseInvoice = "";
            let warningMessage = "";

            // Payment modal can has multiple invoices selected
            if (this.module === "payment-modal") {
                const isSomeInvoiceIdsValid =
                    Array.isArray(this.invoiceIds) &&
                    this.invoiceIds.length > 0 &&
                    this.invoiceIds.some(invoiceId => {
                        return (
                            (typeof invoiceId === "string" ||
                                invoiceId instanceof String) &&
                            !isNil(invoiceId) &&
                            trim(invoiceId) !== ""
                        );
                    });

                if (isSomeInvoiceIdsValid) {
                    let users = this.$store.getters[
                        "billing/findUserChooseInvoices"
                    ](this.invoiceIds);

                    // Only show 1 person
                    userChooseInvoice = users.length > 0 ? users[0] : null;
                }
            } else {
                const isInvoiceIdValid =
                    this.invoiceId &&
                    (typeof this.invoiceId === "string" ||
                        this.invoiceId instanceof String) &&
                    !isNil(this.invoiceId) &&
                    trim(this.invoiceId) !== "";

                if (isInvoiceIdValid) {
                    userChooseInvoice = this.$store.getters[
                        "billing/findUserChooseInvoice"
                    ](this.invoiceId);
                }
            }
            if (!isEmpty(userChooseInvoice)) {
                switch (this.module) {
                    case "medical-record":
                        warningMessage = `${userChooseInvoice.userName} is currently creating a new payment for the invoice associated with this medical record. Please wait until the transaction is completed to allow for a recalculation of the balance to avoid conflicts with reconciliation.`;
                        break;
                    case "invoice":
                    case "patient-invoice":
                        warningMessage = `${userChooseInvoice.userName} is currently creating a new payment for this invoice. Please wait until the transaction is completed to allow for a recalculation of the balance to avoid conflicts with reconciliation. `;
                        if (this.module !== "patient-invoice") {
                            warningMessage +=
                                "This page will be refreshed once the payment is completed.";
                        }
                        break;
                    case "payment-modal":
                        warningMessage = `${userChooseInvoice.userName} is currently creating a new payment for this invoice. Please wait until the transaction is completed to allow for a recalculation of the balance to avoid conflicts with reconciliation. `;
                        break;
                    default:
                        break;
                }
            }
            return warningMessage;
        }
    }
};
</script>
